import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper } from '@material-ui/core';
import { MODAL_TYPE, useModals } from '../hooks/useModal';

function ImageSlider({ images }) {
    const { showModal } = useModals();
    if (!images) {
        return null;
    }
    return (
        <Paper>
            <Carousel
                indicators={images.length > 0}
                navButtonsAlwaysInvisible={images.length > 0}
                indicatorContainerProps={{
                    style: {
                        position: 'absolute',
                        bottom: '8px',
                        opacity: '.5'
                    }
                }}
            >
                {images.map((item, i) => (
                    <div
                        onClick={() =>
                            showModal(MODAL_TYPE.IMAGE_SLIDER_MODAL, {
                                images,
                                currentImage: i
                            })
                        }
                        // eslint-disable-next-line react/no-array-index-key
                        key={i}
                        style={{
                            borderRadius: '4px',
                            paddingBottom: '50%',
                            backgroundImage: `url("${item}")`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            cursor: 'pointer'
                        }}
                    ></div>
                ))}
            </Carousel>
        </Paper>
    );
}

export default ImageSlider;
